var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component, createRef } from "react";
import { motion } from "framer-motion";
import { X, Maximize2, Minimize2, Move, Circle, Square, Send, ChevronUp, ChevronDown } from "lucide-react";
import { MdFullscreen, MdFullscreenExit } from 'react-icons/md';
import { Rnd } from "react-rnd";
import { ConnectionState } from "livekit-client";
import { LiveKitRoom, VideoTrack, useVoiceAssistant, useConnectionState, RoomAudioRenderer, StartAudio, useLocalParticipant, useChat, useTrackTranscription, useRoomContext } from "@livekit/components-react";
import { Track, RoomEvent } from 'livekit-client';
import Tooltip from './ui/Tooltip';
import { VideoAudioSwitch } from './ui/video-audio-switch';
import { FloatingButton } from './ui/floating-button';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { env } from '../config/env';
// CSS for thin invisible scrollbar
var scrollbarStyles = "\n  .talkbot-overlay-scroll::-webkit-scrollbar {\n    width: 4px;\n  }\n  .talkbot-overlay-scroll::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  .talkbot-overlay-scroll::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.5);\n    border-radius: 2px;\n  }\n  .talkbot-overlay-scroll::-webkit-scrollbar-thumb:hover {\n    background: rgba(255, 255, 255, 0.8);\n  }\n";
// Inject styles
if (typeof document !== 'undefined') {
    var style = document.createElement('style');
    style.textContent = scrollbarStyles;
    document.head.appendChild(style);
}
// Helper function for device detection
function getDeviceType() {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return isMobile ? 'mobile' : 'desktop';
}
// Inner component to use LiveKit hooks
var SimpleAvatarInner = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var isCircle = _a.isCircle, windowSize = _a.windowSize, isVoiceMode = _a.isVoiceMode, isInputExpanded = _a.isInputExpanded;
    var _d = useVoiceAssistant(), agent = _d.agent, videoTrack = _d.videoTrack, audioTrack = _d.audioTrack, agentState = _d.state;
    var isSessionActive = React.useMemo(function () {
        var s = String(agentState || '').toLowerCase();
        return s === 'sessionactive';
    }, [agentState]);
    var connectionState = useConnectionState();
    var localApi = useLocalParticipant();
    var room = useRoomContext();
    var _e = useChat(), sendChat = _e.send, chatMessages = _e.chatMessages; // include chatMessages for debugging
    // Expose sendText method through ref (same pattern as LiveKitChatWrapper)
    React.useImperativeHandle(ref, function () { return ({
        sendText: function (text) {
            var trimmed = text.trim();
            if (trimmed) {
                console.log('Sending text to LiveKit chat:', trimmed);
                sendChat(trimmed); // Same as VoiceBot.tsx - LiveKit does the rest
            }
        }
    }); }, [sendChat]); // Keep fresh if the room changes
    // Debug: log incoming chat messages
    React.useEffect(function () {
        console.log('[AvatarWidget Overlay] chatMessages count:', chatMessages.length, chatMessages);
    }, [chatMessages]);
    // Track transcriptions: agent (remote audio) and local mic
    var agentTranscription = useTrackTranscription(audioTrack && audioTrack
        ? {
            publication: audioTrack.publication,
            source: (_b = audioTrack.source) !== null && _b !== void 0 ? _b : Track.Source.Microphone,
            participant: audioTrack.participant,
        }
        : undefined);
    var localUser = (_c = localApi === null || localApi === void 0 ? void 0 : localApi.localParticipant) !== null && _c !== void 0 ? _c : localApi;
    var localMicPub = React.useMemo(function () {
        var micFromApi = localApi === null || localApi === void 0 ? void 0 : localApi.microphoneTrack;
        if (micFromApi)
            return micFromApi;
        var lp = localUser;
        if (!lp || typeof lp.getTrackPublications !== 'function')
            return undefined;
        var pubs = Array.from(lp.getTrackPublications().values());
        return pubs.find(function (p) { return (p === null || p === void 0 ? void 0 : p.kind) === 'audio' || (p === null || p === void 0 ? void 0 : p.source) === Track.Source.Microphone; });
    }, [localApi, localUser]);
    var localTranscription = useTrackTranscription(localMicPub && localUser
        ? {
            publication: localMicPub,
            source: Track.Source.Microphone,
            participant: localUser,
        }
        : undefined);
    React.useEffect(function () {
        console.log('[AvatarWidget Overlay] agent segments:', agentTranscription.segments);
    }, [agentTranscription.segments]);
    React.useEffect(function () {
        console.log('[AvatarWidget Overlay] local segments:', localTranscription.segments);
    }, [localTranscription.segments]);
    // Debug: log agentState and isSessionActive
    React.useEffect(function () {
        console.log('[AvatarWidget Overlay] agentState:', agentState, 'isSessionActive:', isSessionActive);
    }, [agentState, isSessionActive]);
    // Fallback: listen for LiveKit data packets with topic 'lk.transcription'
    var _f = React.useState([]), dataTranscripts = _f[0], setDataTranscripts = _f[1];
    React.useEffect(function () {
        if (!room)
            return;
        var handler = function (payload, participant, _kind, topic) {
            var _a;
            try {
                if (topic === 'lk.transcription') {
                    var text_1 = new TextDecoder().decode(payload);
                    // Try JSON parse first
                    try {
                        var obj = JSON.parse(text_1);
                        var line_1 = (obj === null || obj === void 0 ? void 0 : obj.text) || (obj === null || obj === void 0 ? void 0 : obj.message) || ((_a = obj === null || obj === void 0 ? void 0 : obj.segment) === null || _a === void 0 ? void 0 : _a.text) || text_1;
                        setDataTranscripts(function (prev) { return __spreadArray(__spreadArray([], prev, true), [line_1], false).slice(-10); });
                        console.log('[AvatarWidget Overlay] lk.transcription:', obj);
                    }
                    catch (_b) {
                        setDataTranscripts(function (prev) { return __spreadArray(__spreadArray([], prev, true), [text_1], false).slice(-10); });
                        console.log('[AvatarWidget Overlay] lk.transcription text:', text_1);
                    }
                }
                else if (topic) {
                    // Log other topics for visibility
                    console.log('[AvatarWidget Overlay] DataReceived topic:', topic);
                }
            }
            catch (e) {
                console.warn('DataReceived handler error:', e);
            }
        };
        room.on(RoomEvent.DataReceived, handler);
        return function () {
            room.off(RoomEvent.DataReceived, handler);
        };
    }, [room]);
    var transcriptItems = React.useMemo(function () {
        var items = [];
        var index = 0;
        try {
            // Prepare all messages from all sources with their source info
            // Include BOTH partial (final: false) and final (final: true) segments for live updates
            var agentItems = agentTranscription.segments
                .filter(function (s) { var _a; return (_a = s === null || s === void 0 ? void 0 : s.text) === null || _a === void 0 ? void 0 : _a.trim(); })
                .map(function (s) { return ({ side: 'left', text: s.text, source: 'agent' }); });
            var localItems = localTranscription.segments
                .filter(function (s) { var _a; return (_a = s === null || s === void 0 ? void 0 : s.text) === null || _a === void 0 ? void 0 : _a.trim(); })
                .map(function (s) { return ({ side: 'right', text: s.text, source: 'local' }); });
            var localSid_1 = localUser === null || localUser === void 0 ? void 0 : localUser.sid;
            var chatItems = chatMessages
                .map(function (m) {
                var _a;
                var from = (m === null || m === void 0 ? void 0 : m.from) || {};
                var isSelf = !!((from.sid && localSid_1 && from.sid === localSid_1) ||
                    (from.identity && (localUser === null || localUser === void 0 ? void 0 : localUser.identity) && from.identity === localUser.identity) ||
                    (from.isLocal === true));
                var msg = (_a = m === null || m === void 0 ? void 0 : m.message) !== null && _a !== void 0 ? _a : '';
                return String(msg).trim() ? { side: isSelf ? 'right' : 'left', text: msg, source: isSelf ? 'self-chat' : 'ai-chat' } : null;
            })
                .filter(function (item) { return item !== null; });
            var dataItems = dataTranscripts
                .filter(function (t) { return t && String(t).trim(); })
                .map(function (t) { return ({ side: 'left', text: String(t), source: 'data' }); });
            // Interleave messages chronologically by round-robin through sources
            var maxLen = Math.max(agentItems.length, localItems.length, chatItems.length, dataItems.length);
            for (var i = 0; i < maxLen; i++) {
                if (i < agentItems.length)
                    items.push(__assign(__assign({}, agentItems[i]), { index: index++ }));
                if (i < localItems.length)
                    items.push(__assign(__assign({}, localItems[i]), { index: index++ }));
                if (i < chatItems.length)
                    items.push(__assign(__assign({}, chatItems[i]), { index: index++ }));
                if (i < dataItems.length)
                    items.push(__assign(__assign({}, dataItems[i]), { index: index++ }));
            }
        }
        catch (_a) { }
        return items.slice(-10);
    }, [agentTranscription.segments, localTranscription.segments, chatMessages, localUser, dataTranscripts]);
    // Auto-scroll overlay to latest message after full completion
    var overlayRef = React.useRef(null);
    React.useEffect(function () {
        var el = overlayRef.current;
        if (!el)
            return;
        // Use requestAnimationFrame to ensure scroll happens after render
        requestAnimationFrame(function () {
            el.scrollTop = el.scrollHeight;
        });
    }, [transcriptItems]);
    // Audio animation component for voice mode
    var AudioAnimation = function () { return (React.createElement("div", { className: "flex items-center justify-center space-x-1" },
        React.createElement("div", { className: "w-2 h-8 bg-blue-400 rounded-full animate-pulse", style: { animationDelay: '0ms', animationDuration: '1s' } }),
        React.createElement("div", { className: "w-2 h-12 bg-blue-500 rounded-full animate-pulse", style: { animationDelay: '150ms', animationDuration: '1s' } }),
        React.createElement("div", { className: "w-2 h-6 bg-blue-400 rounded-full animate-pulse", style: { animationDelay: '300ms', animationDuration: '1s' } }),
        React.createElement("div", { className: "w-2 h-10 bg-blue-500 rounded-full animate-pulse", style: { animationDelay: '450ms', animationDuration: '1s' } }),
        React.createElement("div", { className: "w-2 h-8 bg-blue-400 rounded-full animate-pulse", style: { animationDelay: '600ms', animationDuration: '1s' } }))); };
    // Helper to linkify URLs in text
    // Helper to linkify both markdown-style [text](url) and plain URLs
    function linkify(text) {
        // First, replace markdown links [text](url)
        var mdLinkRegex = /\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g;
        var replaced = text.replace(mdLinkRegex, function (match, linkText, url) {
            return "<a href=\"".concat(url, "\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"color:#60a5fa;text-decoration:underline;\">").concat(linkText, "</a>");
        });
        // Then, replace plain URLs (not already inside an anchor)
        var urlRegex = /(?<![\">])(https?:\/\/(?:[\w-]+\.)+[\w-]+(?:\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?)/gi;
        replaced = replaced.replace(urlRegex, function (url) {
            return "<a href=\"".concat(url, "\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"color:#60a5fa;text-decoration:underline;\">").concat(url, "</a>");
        });
        return replaced;
    }
    return (React.createElement("div", { className: "w-full h-full flex items-center justify-center bg-black ".concat(isCircle ? 'rounded-full' : '') },
        React.createElement(RoomAudioRenderer, null),
        React.createElement(StartAudio, { label: "Start Audio" }),
        React.createElement("div", { ref: overlayRef, style: {
                position: 'absolute',
                bottom: isInputExpanded ? 100 : 55,
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
                gap: 6,
                width: '90%',
                pointerEvents: 'auto',
                height: '100px',
                overflowY: 'auto',
                left: '5%',
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(255,255,255,0.4) transparent',
                transition: 'bottom 0.3s ease',
            }, className: "talkbot-overlay-scroll" }, transcriptItems.map(function (item) { return (React.createElement("div", { key: item.index, style: {
                display: 'flex',
                justifyContent: item.side === 'left' ? 'flex-start' : 'flex-end',
                width: '100%',
            } },
            React.createElement("div", { style: {
                    padding: '6px 8px',
                    borderRadius: 12,
                    background: item.side === 'left' ? 'rgba(255, 255, 255, 0.37)' : 'rgba(0, 0, 0, 0.37)',
                    color: '#fff',
                    fontSize: 11,
                    lineHeight: 1.3,
                    maxWidth: '75%',
                    pointerEvents: 'auto',
                }, dangerouslySetInnerHTML: { __html: linkify(item.text) } }))); })),
        videoTrack && !isVoiceMode ? (React.createElement("div", { className: "w-full h-full overflow-hidden ".concat(isCircle ? 'rounded-full' : ''), style: {
                position: 'relative',
                width: '100%',
                height: '100%'
            } },
            React.createElement(VideoTrack, { trackRef: videoTrack, className: "w-full h-full ".concat(isCircle ? 'rounded-full' : ''), style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    transition: 'all 0.3s ease'
                } }))) : (React.createElement("div", { className: "fixed top-[30%] text-center text-white" }, connectionState === ConnectionState.Connected ? (React.createElement(React.Fragment, null, isVoiceMode ? (React.createElement(React.Fragment, null,
            React.createElement(AudioAnimation, null),
            React.createElement("p", { className: "text-sm mt-4" }, "Voice Assistant Active"),
            React.createElement("p", { className: "text-xs mt-2 opacity-70" },
                "State: ",
                agentState))) : (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "text-sm" }, "Waiting for Avatar..."),
            React.createElement("p", { className: "text-xs mt-2 opacity-70" },
                "State: ",
                agentState))))) : connectionState === ConnectionState.Connecting ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4" }),
            React.createElement("p", { className: "text-sm" }, "Connecting..."))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "text-4xl mb-4" }, "\u274C"),
            React.createElement("p", { className: "text-sm" }, "Connection Failed")))))));
});
var getDefaultWindowSize = function () {
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    if (getDeviceType() === 'mobile') {
        // Mobile: More aggressive responsive sizing
        return {
            width: Math.min(vw * 0.85, 320),
            height: Math.min(vh * 0.6, 400)
        };
    }
    else {
        // Desktop: Responsive but with reasonable limits
        return {
            width: Math.min(vw * 0.3, 400),
            height: Math.min(vh * 0.6, 500)
        };
    }
};
var SimpleAvatarWidget = /** @class */ (function (_super) {
    __extends(SimpleAvatarWidget, _super);
    function SimpleAvatarWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.startPos = { x: 0, y: 0 };
        _this.startSize = { width: 400, height: 500 };
        _this.handleWindowResize = function () {
            var isFullScreen = _this.state.isFullScreen;
            if (isFullScreen) {
                _this.setState({
                    windowSize: {
                        width: window.innerWidth,
                        height: window.innerHeight
                    }
                });
            }
            else {
                _this.adjustPositionToBounds();
            }
        };
        // Handle orientation change (mainly for mobile)
        _this.handleOrientationChange = function () {
            setTimeout(function () {
                _this.handleWindowResize();
                _this.forceUpdate();
            }, 100);
        };
        _this.adjustPositionToBounds = function () {
            var _a = _this.state, dragPosition = _a.dragPosition, windowSize = _a.windowSize;
            var vw = window.innerWidth;
            var vh = window.innerHeight;
            var newX = dragPosition.x;
            var newY = dragPosition.y;
            // Ensure widget stays within horizontal bounds
            if (newX + windowSize.width > vw) {
                newX = vw - windowSize.width - 10;
            }
            if (newX < 0) {
                newX = 10;
            }
            // Ensure widget stays within vertical bounds
            if (newY + windowSize.height > vh) {
                newY = vh - windowSize.height - 10;
            }
            if (newY < 0) {
                newY = 10;
            }
            // Update position if it changed
            if (newX !== dragPosition.x || newY !== dragPosition.y) {
                _this.setState({
                    dragPosition: { x: newX, y: newY }
                });
            }
        };
        // Generate connection details using your API
        _this.generateConnectionDetails = function () { return __awaiter(_this, void 0, void 0, function () {
            var apiBaseUrl, _a, userEmail, userContact, videoMode, domain, mode, params, response, data, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        apiBaseUrl = env.livekitTokenUrl;
                        _a = this.state, userEmail = _a.userEmail, userContact = _a.userContact, videoMode = _a.videoMode;
                        domain = window.location.hostname;
                        mode = videoMode ? 'avatar' : 'voice';
                        this.setState({ isLoading: true, error: null });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        params = new URLSearchParams({
                            domain: domain,
                            mode: mode,
                            email: userEmail,
                            contact: userContact
                        });
                        return [4 /*yield*/, fetch("".concat(apiBaseUrl, "/api/token?").concat(params.toString()))];
                    case 2:
                        response = _b.sent();
                        if (!response.ok) {
                            throw new Error("Token fetch failed: ".concat(response.statusText));
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        data = _b.sent();
                        // Validate that we received all required fields
                        if (!data.serverUrl || !data.roomName || !data.participantToken || !data.participantName) {
                            throw new Error('Incomplete connection details received from server');
                        }
                        this.setState({
                            connectionDetails: data,
                            isLoading: false,
                            showForm: false
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        console.error('Failed to generate connection details:', error_1);
                        this.setState({
                            error: "Connection failed: ".concat(error_1 instanceof Error ? error_1.message : 'Unknown error'),
                            isLoading: false
                        });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // Form validation
        _this.validateForm = function () {
            var _a = _this.state, userEmail = _a.userEmail, userContact = _a.userContact;
            var errors = {};
            // Email validation
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!userEmail.trim()) {
                errors.email = 'Email is required';
            }
            else if (!emailRegex.test(userEmail)) {
                errors.email = 'Please enter a valid email address';
            }
            // Contact validation
            var contactRegex = /^[\+]?[1-9][\d]{0,15}$/;
            if (!userContact.trim()) {
                errors.contact = 'Contact number is required';
            }
            else if (!contactRegex.test(userContact.replace(/[-\s\(\)]/g, ''))) {
                errors.contact = 'Please enter a valid contact number';
            }
            _this.setState({ formErrors: errors });
            return Object.keys(errors).length === 0;
        };
        // Handle form submission
        _this.handleFormSubmit = function (e) {
            e.preventDefault();
            if (_this.validateForm()) {
                // Form is valid, proceed with connection
                _this.generateConnectionDetails();
            }
        };
        // Handle input changes
        _this.handleInputChange = function (field, value) {
            var _a, _b;
            _this.setState((_a = {},
                _a[field] = value,
                _a.formErrors = __assign(__assign({}, _this.state.formErrors), (_b = {}, _b[field.replace('user', '').toLowerCase()] = undefined, _b)),
                _a));
        };
        // Handle mouse events for resizing
        _this.handleMouseMove = function (e) {
            if (!_this.state.isResizing)
                return;
            var deltaX = e.clientX - _this.startPos.x;
            var deltaY = e.clientY - _this.startPos.y;
            var newWidth = Math.max(300, _this.startSize.width + deltaX);
            var newHeight = Math.max(400, _this.startSize.height + deltaY);
            _this.setState({ windowSize: { width: newWidth, height: newHeight } });
        };
        _this.handleMouseUp = function () {
            if (_this.state.isResizing) {
                _this.setState({ isResizing: false });
                document.body.style.cursor = 'default';
            }
        };
        // Add fullscreen functionality for the widget itself
        _this.handleToggleFullScreen = function () {
            _this.setState(function (prevState) {
                var newIsFullScreen = !prevState.isFullScreen;
                var vw = window.innerWidth;
                var vh = window.innerHeight;
                if (newIsFullScreen) {
                    // Entering fullscreen - save current position and make widget cover viewport
                    return __assign(__assign({}, prevState), { isFullScreen: true, shape: 'box', dragPosition: { x: 0, y: 0 }, windowSize: {
                            width: vw,
                            height: vh
                        } });
                }
                else {
                    // Exiting fullscreen - restore to default size and position
                    var defaultSize = getDefaultWindowSize();
                    var isMobile = getDeviceType() === 'mobile';
                    var margin = isMobile ? Math.min(vw * 0.03, 15) : Math.min(vw * 0.02, 20);
                    var newX = _this.props.side === 'right' ? vw - defaultSize.width - margin : margin;
                    var newY = vh - defaultSize.height - (isMobile ? Math.min(vh * 0.1, 80) : Math.min(vh * 0.12, 90));
                    return __assign(__assign({}, prevState), { isFullScreen: false, dragPosition: { x: newX, y: newY }, windowSize: defaultSize });
                }
            }, function () {
                // Force a layout recalculation after fullscreen toggle
                setTimeout(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 150);
            });
        };
        // Toggle between video mode (avatar) and voice mode (defaultMode)
        _this.toggleVideoMode = function () {
            _this.setState(function (prevState) { return ({
                videoMode: !prevState.videoMode
            }); });
        };
        // Send message to LiveKit (same pattern as ChatbotWindow)
        _this.sendMessage = function () {
            if (_this.state.message.trim() === '')
                return;
            // Use sendText method like ChatbotWindow
            if (_this.liveKitRef.current && _this.liveKitRef.current.sendText) {
                _this.liveKitRef.current.sendText(_this.state.message);
            }
            else {
                console.warn('LiveKit ref not available or sendText method not found');
            }
            // Clear the message input
            _this.setState({ message: '' });
        };
        // Handle key press for message input
        _this.handleKeyPress = function (e) {
            if (e.key === 'Enter') {
                _this.sendMessage();
            }
        };
        // Toggle input area expansion
        _this.toggleInputExpand = function () {
            _this.setState(function (prevState) { return ({
                isInputExpanded: !prevState.isInputExpanded
            }); });
        };
        var defaultSize = getDefaultWindowSize();
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        var isMobile = getDeviceType() === 'mobile';
        // Responsive margins
        var margin = isMobile ? Math.min(vw * 0.03, 15) : Math.min(vw * 0.02, 20);
        // Responsive positioning
        var initialX = props.side === 'right'
            ? vw - defaultSize.width - margin
            : margin;
        var initialY = vh - defaultSize.height - (isMobile ? Math.min(vh * 0.1, 80) : Math.min(vh * 0.12, 90));
        _this.state = {
            windowSize: defaultSize,
            isResizing: false,
            shape: 'box',
            isFullScreen: false,
            dragPosition: { x: initialX, y: initialY },
            // LiveKit state
            connectionDetails: null,
            isLoading: false,
            error: null,
            // User form state
            showForm: true,
            userEmail: '',
            userContact: '',
            formErrors: {},
            // Video/Voice mode state
            videoMode: false, // Default to avatar mode
            // Message input state
            message: '',
            isInputExpanded: false,
        };
        _this.windowRef = createRef();
        _this.liveKitRef = createRef();
        // Bind handlers
        _this.toggleShape = _this.toggleShape.bind(_this);
        _this.handleMaximize = _this.handleMaximize.bind(_this);
        _this.handleMinimize = _this.handleMinimize.bind(_this);
        _this.handleResizeStart = _this.handleResizeStart.bind(_this);
        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
        _this.handleMouseUp = _this.handleMouseUp.bind(_this);
        _this.toggleSizeOption = _this.toggleSizeOption.bind(_this);
        _this.handleToggleFullScreen = _this.handleToggleFullScreen.bind(_this);
        _this.toggleVideoMode = _this.toggleVideoMode.bind(_this);
        _this.sendMessage = _this.sendMessage.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.toggleInputExpand = _this.toggleInputExpand.bind(_this);
        return _this;
    }
    SimpleAvatarWidget.prototype.componentDidMount = function () {
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
        window.addEventListener('resize', this.handleWindowResize);
        window.addEventListener('orientationchange', this.handleOrientationChange);
    };
    SimpleAvatarWidget.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.windowSize.width !== this.state.windowSize.width ||
            prevState.windowSize.height !== this.state.windowSize.height ||
            prevState.shape !== this.state.shape) {
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 100);
        }
    };
    SimpleAvatarWidget.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
        window.removeEventListener('resize', this.handleWindowResize);
        window.removeEventListener('orientationchange', this.handleOrientationChange);
    };
    SimpleAvatarWidget.prototype.handleResizeStart = function (e) {
        e.preventDefault();
        this.setState({ isResizing: true });
        this.startPos = { x: e.clientX, y: e.clientY };
        this.startSize = __assign({}, this.state.windowSize);
        document.body.style.cursor = 'nwse-resize';
    };
    SimpleAvatarWidget.prototype.toggleShape = function () {
        this.setState(function (prevState) { return ({
            shape: prevState.shape === 'box' ? 'circle' : 'box'
        }); }, function () {
            // Force a layout recalculation after shape change
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 150);
        });
    };
    SimpleAvatarWidget.prototype.handleMaximize = function () {
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        var isMobile = getDeviceType() === 'mobile';
        var maxSize = {
            width: isMobile
                ? Math.min(vw * 0.95, 420)
                : Math.min(vw * 0.7, 800),
            height: isMobile
                ? Math.min(vh * 0.85, 600)
                : Math.min(vh * 0.8, 700)
        };
        this.setState({ windowSize: maxSize }, function () {
            // Force a layout recalculation after state update
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 150);
        });
    };
    SimpleAvatarWidget.prototype.handleMinimize = function () {
        this.setState({ windowSize: getDefaultWindowSize() }, function () {
            // Force a layout recalculation after state update
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 150);
        });
    };
    // Toggle size between small, medium, large like ChatbotWidget
    SimpleAvatarWidget.prototype.toggleSizeOption = function () {
        var windowSize = this.state.windowSize;
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        var isMobile = getDeviceType() === 'mobile';
        // Define responsive sizes based on viewport
        var sizes = isMobile
            ? [
                { width: Math.min(vw * 0.7, 280), height: Math.min(vh * 0.5, 360) }, // Small
                { width: Math.min(vw * 0.85, 350), height: Math.min(vh * 0.65, 450) }, // Medium  
                { width: Math.min(vw * 0.95, 420), height: Math.min(vh * 0.8, 550) }, // Large
            ]
            : [
                { width: Math.min(vw * 0.25, 300), height: Math.min(vh * 0.5, 400) }, // Small
                { width: Math.min(vw * 0.4, 500), height: Math.min(vh * 0.7, 600) }, // Medium
                { width: Math.min(vw * 0.6, 700), height: Math.min(vh * 0.85, 800) }, // Large
            ];
        // Find current size in the array
        var currentIndex = sizes.findIndex(function (size) {
            var widthDiff = Math.abs(windowSize.width - size.width);
            var heightDiff = Math.abs(windowSize.height - size.height);
            return widthDiff < (isMobile ? 30 : 50) && heightDiff < (isMobile ? 40 : 60);
        });
        var nextIndex = (currentIndex + 1) % sizes.length;
        this.setState({ windowSize: sizes[nextIndex] }, function () {
            // Force a layout recalculation after state update
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 150);
        });
    };
    SimpleAvatarWidget.prototype.getSizeIcon = function () {
        var windowSize = this.state.windowSize;
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        var isMobile = getDeviceType() === 'mobile';
        if (isMobile) {
            // Mobile: determine icon based on viewport percentage
            var widthPercent = windowSize.width / vw;
            if (widthPercent <= 0.75) {
                return React.createElement(Minimize2, { size: 14 }); // Small
            }
            else if (widthPercent <= 0.9) {
                return React.createElement(Maximize2, { size: 16 }); // Medium
            }
            else {
                return React.createElement(Maximize2, { size: 18 }); // Large
            }
        }
        else {
            // Desktop: determine icon based on viewport percentage
            var widthPercent = windowSize.width / vw;
            if (widthPercent <= 0.3) {
                return React.createElement(Minimize2, { size: 16 }); // Small
            }
            else if (widthPercent <= 0.5) {
                return React.createElement(Maximize2, { size: 16 }); // Medium
            }
            else {
                return React.createElement(Maximize2, { size: 18 }); // Large
            }
        }
    };
    SimpleAvatarWidget.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, side = _b.side, header = _b.header, onClose = _b.onClose, verticalPosition = _b.verticalPosition;
        var _c = this.state, windowSize = _c.windowSize, shape = _c.shape, isFullScreen = _c.isFullScreen, connectionDetails = _c.connectionDetails, isLoading = _c.isLoading, error = _c.error;
        var fixedPosition = (_a = {
                bottom: 90,
                top: 0
            },
            _a[side] = 20,
            _a);
        return (React.createElement(Rnd, { ref: this.windowRef, className: "fixed bg-white shadow-2xl border border-gray-200 z-50 transition-all duration-300 overflow-hidden ".concat(shape === 'circle' ? 'rounded-full aspect-square' : 'rounded-lg', " ").concat(isFullScreen ? 'z-[9999]' : ''), size: {
                width: windowSize.width,
                height: shape === 'circle' ? windowSize.width : windowSize.height
            }, onDragStop: function (e, d) {
                _this.setState({
                    dragPosition: { x: d.x, y: d.y },
                });
            }, onResizeStop: function (e, direction, ref, delta, position) {
                _this.setState({
                    windowSize: {
                        width: ref.offsetWidth,
                        height: ref.offsetHeight,
                    },
                    dragPosition: {
                        x: position.x,
                        y: position.y,
                    },
                });
            }, default: {
                x: fixedPosition[side],
                y: fixedPosition[verticalPosition],
                width: windowSize.width,
                height: shape === 'circle' ? windowSize.width : windowSize.height,
            }, minWidth: isFullScreen ? window.innerWidth : (shape !== "circle" ? Math.min(window.innerWidth * 0.2, 300) : Math.min(window.innerWidth * 0.15, 120)), minHeight: isFullScreen ? window.innerHeight : (shape !== "circle" ? Math.min(window.innerHeight * 0.3, 400) : Math.min(window.innerHeight * 0.15, 120)), position: { x: this.state.dragPosition.x, y: this.state.dragPosition.y }, bounds: "window", disableDragging: isFullScreen, enableResizing: !isFullScreen, dragHandleClassName: "drag-handle" },
            shape === 'box' && (React.createElement("div", { className: "bg-gradient-to-r from-blue-500 to-purple-600 p-4 flex justify-between items-center text-white" },
                React.createElement("div", { className: "flex items-center flex-1" },
                    React.createElement("div", { className: "drag-handle cursor-move p-2 mr-1" },
                        React.createElement(Move, { size: getDeviceType() === 'mobile' ? 14 : 16 })),
                    (header === null || header === void 0 ? void 0 : header.logoUrl) ? (React.createElement("img", { src: header.logoUrl, alt: "logo", className: "ml-2 h-8 w-8 rounded-full bg-white object-cover" })) : (React.createElement("div", { className: "ml-2 h-8 w-8 rounded-full bg-white flex items-center justify-center" },
                        React.createElement("span", { className: "text-blue-600 font-bold text-xs" }, "AI"))),
                    React.createElement("div", { className: "ml-2" },
                        React.createElement("h3", { className: "font-medium ".concat(getDeviceType() === 'mobile' ? 'text-sm' : 'text-base') }, (header === null || header === void 0 ? void 0 : header.title) || 'Talkbot'),
                        React.createElement("p", { className: "text-xs opacity-80" }, connectionDetails ? 'Connected' :
                            isLoading ? 'Connecting...' :
                                this.state.showForm ? 'Enter your details' : 'Disconnected'))),
                React.createElement("div", { className: "flex space-x-1 items-center" },
                    React.createElement(Tooltip, { content: "Change Shape" },
                        React.createElement("button", { onClick: this.toggleShape, className: "text-white hover:text-gray-200 align-middle", style: {
                                padding: getDeviceType() === 'mobile' ? '12px' : '8px',
                                minWidth: getDeviceType() === 'mobile' ? '44px' : 'auto',
                                minHeight: getDeviceType() === 'mobile' ? '44px' : 'auto'
                            }, title: "Toggle Circle" },
                            React.createElement(Circle, { size: getDeviceType() === 'mobile' ? 18 : 16 }))),
                    getDeviceType() !== 'mobile' && (React.createElement(Tooltip, { content: windowSize.width <= window.innerWidth * 0.3 ? "Maximize" : "Minimize" }, windowSize.width <= window.innerWidth * 0.3 ? (React.createElement("button", { onClick: this.handleMaximize, className: "text-white hover:text-gray-200 align-middle", style: { padding: '8px' }, title: "Maximize" },
                        React.createElement(Maximize2, { size: 18 }))) : (React.createElement("button", { onClick: this.handleMinimize, className: "text-white hover:text-gray-200 align-middle", style: { padding: '8px' }, title: "Minimize" },
                        React.createElement(Minimize2, { size: 18 }))))),
                    React.createElement(Tooltip, { content: isFullScreen ? "Exit Fullscreen" : "Fullscreen" },
                        React.createElement("button", { onClick: this.handleToggleFullScreen, className: "text-white hover:text-gray-200 align-middle", style: {
                                padding: getDeviceType() === 'mobile' ? '12px' : '8px',
                                minWidth: getDeviceType() === 'mobile' ? '44px' : 'auto',
                                minHeight: getDeviceType() === 'mobile' ? '44px' : 'auto'
                            }, title: isFullScreen ? "Exit Fullscreen" : "Fullscreen" }, isFullScreen ?
                            React.createElement(MdFullscreenExit, { size: getDeviceType() === 'mobile' ? 20 : 18 }) :
                            React.createElement(MdFullscreen, { size: getDeviceType() === 'mobile' ? 20 : 18 }))),
                    React.createElement(Tooltip, { content: "Close" },
                        React.createElement("button", { onClick: onClose, className: "text-white hover:text-gray-200 align-middle", style: {
                                padding: getDeviceType() === 'mobile' ? '12px' : '8px',
                                minWidth: getDeviceType() === 'mobile' ? '44px' : 'auto',
                                minHeight: getDeviceType() === 'mobile' ? '44px' : 'auto'
                            }, title: "Close" },
                            React.createElement(X, { size: getDeviceType() === 'mobile' ? 18 : 16 })))))),
            React.createElement("div", { className: "h-full flex flex-col", style: {
                    height: shape === 'circle'
                        ? '100%'
                        : 'calc(100% - 64px)'
                } },
                error && (React.createElement("div", { className: "p-4 bg-red-50 border-b border-red-200" },
                    React.createElement("div", { className: "text-red-800 text-sm" },
                        React.createElement("p", { className: "font-medium" }, "Connection Error"),
                        React.createElement("p", { className: "text-xs mt-1" }, error),
                        React.createElement("button", { onClick: function () { return _this.setState({ showForm: true, error: null }); }, className: "mt-2 px-3 py-1 bg-red-600 text-white text-xs rounded hover:bg-red-700 transition-colors" }, "Try Again")))),
                React.createElement("div", { className: "flex-1 relative ".concat(shape === 'circle' ? 'rounded-full overflow-hidden' : '') }, this.state.showForm ? (
                // User Information Form
                React.createElement("div", { className: "w-full h-full flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50 ".concat(shape === 'circle' ? 'rounded-full' : '') },
                    React.createElement("div", { className: "w-full max-w-sm p-6" },
                        React.createElement("form", { onSubmit: this.handleFormSubmit, className: "space-y-2" },
                            React.createElement("div", null,
                                React.createElement("label", { className: "block text-sm font-medium text-gray-700 mb-1" }, "Email Address *"),
                                React.createElement("input", { type: "email", value: this.state.userEmail, onChange: function (e) { return _this.handleInputChange('userEmail', e.target.value); }, className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white text-black   text-sm", placeholder: "your.email@example.com", disabled: isLoading }),
                                this.state.formErrors.email && (React.createElement("p", { className: "mt-1 text-xs text-red-600" }, this.state.formErrors.email))),
                            React.createElement("div", null,
                                React.createElement("label", { className: "block text-sm font-medium text-gray-700 mb-1" }, "Contact Number *"),
                                React.createElement("input", { type: "tel", value: this.state.userContact, onChange: function (e) { return _this.handleInputChange('userContact', e.target.value); }, className: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white text-black text-sm", placeholder: "+1 (555) 123-4567", disabled: isLoading }),
                                this.state.formErrors.contact && (React.createElement("p", { className: "mt-1 text-xs text-red-600" }, this.state.formErrors.contact))),
                            React.createElement("div", { className: "w-full flex flex-col items-center gap-2" },
                                React.createElement("label", { className: "text-sm text-gray-600" }, "Conversation Mode"),
                                React.createElement(VideoAudioSwitch, { isVideoMode: this.state.videoMode, onToggle: this.toggleVideoMode, size: "md", className: "mx-auto" })),
                            React.createElement("button", { type: "submit", disabled: isLoading, className: "w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200 text-sm" }, isLoading ? (React.createElement("div", { className: "flex items-center justify-center" },
                                React.createElement("div", { className: "animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" }),
                                "Connecting...")) : ('Connect')))))) : connectionDetails ? (
                // LiveKit Room
                React.createElement(LiveKitRoom, { serverUrl: connectionDetails.serverUrl, token: connectionDetails.participantToken, connect: true, audio: true, video: false, className: "h-full w-full" },
                    React.createElement(SimpleAvatarInner, { ref: this.liveKitRef, isCircle: shape === 'circle', windowSize: windowSize, isVoiceMode: !this.state.videoMode, isInputExpanded: this.state.isInputExpanded }))) : isLoading ? (React.createElement("div", { className: "w-full h-full flex items-center justify-center bg-black text-white ".concat(shape === 'circle' ? 'rounded-full' : '') },
                    React.createElement("div", { className: "text-center" },
                        React.createElement("div", { className: "animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4" }),
                        React.createElement("p", { className: "text-sm" }, "Loading connection details...")))) : (React.createElement("div", { className: "w-full h-full flex items-center justify-center bg-black text-white ".concat(shape === 'circle' ? 'rounded-full' : '') },
                    React.createElement("div", { className: "text-center" },
                        React.createElement("div", { className: "text-4xl mb-4" }, "\u274C"),
                        React.createElement("p", { className: "text-sm" }, "Failed to connect")))))),
            shape === 'box' && connectionDetails && !this.state.showForm && (React.createElement(React.Fragment, null, !this.state.isInputExpanded ? (React.createElement("div", { className: "z-[51] absolute bottom-0 left-0 right-0 flex justify-center items-center space-x-2 mb-2" },
                React.createElement(Tooltip, { content: "Expand input area" },
                    React.createElement(FloatingButton, { onClick: this.toggleInputExpand, icon: React.createElement(ChevronUp, { className: "h-5 w-5" }), "aria-label": "Toggle input area", isInputExpanded: this.state.isInputExpanded, inline: true })))) : (React.createElement(motion.div, { className: "z-[51] absolute bottom-0 left-0 right-0 border-t border-gray-200 bg-white content-center", initial: { height: 0 }, animate: { minHeight: '80px' }, exit: { height: 0 }, transition: { duration: 0.3 } },
                React.createElement(FloatingButton, { onClick: this.toggleInputExpand, icon: React.createElement(ChevronDown, { className: "w-4 h-4", color: 'white' }), "aria-label": "Toggle input area", isInputExpanded: this.state.isInputExpanded }),
                React.createElement("div", { className: "flex items-center space-x-2 p-2" },
                    React.createElement(Input, { placeholder: "Type a message...", value: this.state.message, onChange: function (e) { return _this.setState({ message: e.target.value }); }, onKeyDown: function (e) { return _this.handleKeyPress(e); }, className: "flex-grow resize-none", autoComplete: "off" }),
                    React.createElement(Tooltip, { content: "Send Message" },
                        React.createElement(Button, { onClick: this.sendMessage, variant: "ghost", size: "icon", className: "rounded-full" },
                            React.createElement(Send, { className: "h-5 w-5 text-blue-600" })))))))),
            shape === 'circle' && (React.createElement("div", { className: "absolute top-1 left-1/2 transform -translate-x-1/2 z-[51]" },
                React.createElement("div", { className: "flex space-x-1 bg-white/90 backdrop-blur-sm rounded-full px-2 py-1 shadow-lg" },
                    React.createElement("div", { className: "drag-handle text-blue-500 hover:text-blue-600 cursor-move rounded-full hover:bg-blue-50 transition-colors", style: {
                            padding: getDeviceType() === 'mobile' ? '8px' : '6px',
                            minWidth: getDeviceType() === 'mobile' ? '36px' : 'auto',
                            minHeight: getDeviceType() === 'mobile' ? '36px' : 'auto',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        } },
                        React.createElement(Move, { size: getDeviceType() === 'mobile' ? 16 : 14 })),
                    React.createElement("button", { onClick: this.toggleShape, className: "text-blue-500 hover:text-blue-600 rounded-full hover:bg-blue-50 transition-colors", style: {
                            padding: getDeviceType() === 'mobile' ? '8px' : '6px',
                            minWidth: getDeviceType() === 'mobile' ? '36px' : 'auto',
                            minHeight: getDeviceType() === 'mobile' ? '36px' : 'auto',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }, title: "Expand to box" },
                        React.createElement(Square, { size: getDeviceType() === 'mobile' ? 16 : 14 })),
                    React.createElement("button", { onClick: this.toggleSizeOption, className: "text-blue-500 hover:text-blue-600 rounded-full hover:bg-blue-50 transition-colors", style: {
                            padding: getDeviceType() === 'mobile' ? '8px' : '6px',
                            minWidth: getDeviceType() === 'mobile' ? '36px' : 'auto',
                            minHeight: getDeviceType() === 'mobile' ? '36px' : 'auto',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }, title: "Change Size" }, this.getSizeIcon()))))));
    };
    return SimpleAvatarWidget;
}(Component));
export default SimpleAvatarWidget;
